const SOCIAL_EMAIL_DOMAINS = ['hotmail.com', 'outlook.com', 'gmail.com'];

export function isSocialEmail(email: string) {
  return !!SOCIAL_EMAIL_DOMAINS.find((domain) => email.endsWith(`@${domain}`));
}
